import classnames from 'classnames';

import styles from './Unroll.module.scss';
import { Props } from './Unroll.types';

export const Unroll = ({ children, visible, className, noOpacityFade, immediate }: Props) => {
  return (
    <div
      className={classnames(styles.container, {
        [styles.visible]: visible,
        [styles.noOpacityFade]: noOpacityFade,
        [styles.immediate]: immediate,
      })}
    >
      <div className={className}>{children}</div>
    </div>
  );
};
